export default "__VITE_ASSET__grCAe3f1__"